<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="地区简称" prop="areaName">
        <el-input v-model="queryParams.areaName" placeholder="请输入地区简称" clearable @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="简称长度">
        <el-input
          v-model.number="areaNameLenRange[0]"
          type="number"
          size="small"
          :min="0"
          @keyup.enter.native="handleQuery"
          style="width: 100px"
        /> -
        <el-input
          v-model.number="areaNameLenRange[1]"
          type="number"
          size="small"
          :min="0"
          @keyup.enter.native="handleQuery"
          style="width: 100px"
        />
      </el-form-item>
      <el-form-item label="父级编码" prop="parentCode">
        <el-input v-model="queryParams.parentCode" placeholder="请输入父级编码" clearable @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="地区级别" prop="areaLevel">
        <el-select v-model="queryParams.areaLevel" placeholder="请选择地区级别" @change="handleQuery" clearable>
          <el-option v-for="dict in dict.type.area_level" :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="地区全称" prop="extName">
        <el-input v-model="queryParams.extName" placeholder="请输入地区全称" clearable @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="全称长度">
        <el-input
          v-model.number="extNameLenRange[0]"
          type="number"
          size="small"
          :min="0"
          @keyup.enter.native="handleQuery"
          style="width: 100px"
        /> -
        <el-input
          v-model.number="extNameLenRange[1]"
          type="number"
          size="small"
          :min="0"
          @keyup.enter.native="handleQuery"
          style="width: 100px"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格操作 -->
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['system:area:init']" type="success" plain icon="el-icon-refresh-right" size="mini" @click="handleInit">初始化</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['system:area:refresh']" type="danger" plain icon="el-icon-refresh" size="mini" @click="handleRefreshCache">刷新缓存</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['system:area:export']" type="warning" plain icon="el-icon-download" size="mini" @click="handleExportMultiCounty">导出重名区县</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getChildList" ></right-toolbar>
    </el-row>
    <el-table
      v-show="tableType==='tree'"
      size="small"
      :default-expand-all="isExpandAll"
      :data="treeList"
      row-key="areaCode"
      @row-click="openTree"
      :load="handleNodeClick"
      :cell-style="cellStyle"
      :row-class-name="tableRowClassName"
      lazy
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    >
      <el-table-column label="地区编码" prop="areaCode" min-width="120"/>
      <el-table-column label="地区简称" prop="areaName" />
      <el-table-column label="父级编码" align="center" prop="parentCode" min-width="120"/>
      <el-table-column label="地区级别" align="center" prop="areaLevel" >
        <template slot-scope="scope">
          <dict-tag :options="dict.type.area_level" :value="scope.row.areaLevel"/>
        </template>
      </el-table-column>
      <el-table-column label="地区全称" align="center" prop="extName" />
      <el-table-column label="备注" align="center" prop="remark" />
    </el-table>

    <el-table
      v-show="tableType==='table'"
      size="small"
      :data="areaList"
      row-key="areaCode"
      :background="true"
      :row-class-name="tableRowClassName"
    >
      <el-table-column label="地区编码" prop="areaCode" min-width="120"/>
      <el-table-column label="地区简称" prop="areaName" />
      <el-table-column label="父级编码" align="center" prop="parentCode" min-width="120"/>
      <el-table-column label="地区级别" align="center" prop="areaLevel" >
        <template slot-scope="scope">
          <dict-tag :options="dict.type.area_level" :value="scope.row.areaLevel"/>
        </template>
      </el-table-column>
      <el-table-column label="地区全称" align="center" prop="extName" />
      <el-table-column label="备注" align="center" prop="remark" />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-view" @click="handleView(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
      :page-sizes="[10, 20, 30, 50, 100, 200]"
    />
    <!-- 初始化模态窗 -->
    <el-dialog title="初始化地区" :visible.sync="open" width="300px" :close-on-click-modal="false" >
      <el-form ref="form" :model="form" :rules="rules" label-width="110px" label-suffix="：">
        <el-form-item label="年份" prop="year">
          <el-select v-model="form.year" placeholder="选择年份" size="small" style="width: 120px">
            <el-option v-for="dict in dict.type.area_init_year" :key="dict.value" :label="dict.label" :value="dict.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="是否补全" prop="isAutoFill">
          <span slot="label">
            是否补全
            <el-popover
                    placement="top-start"
                    width="250"
                    trigger="hover"
                    content="如果为是，会自动补全三级地区信息，直辖市增加地级行政区，省直辖县增加地级行政区;否则按照民政部原数据。 三沙市西沙区和南沙区官网未设置编码，会自动设置">
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </span>
          <el-switch v-model="form.isAutoFill" active-text="是" :active-value="true" :inactive-value="false" inactive-text="否" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitInitForm">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog title="地区详情" :visible.sync="viewOpen" width="400px">
      <el-form ref="viewForm" :model="viewForm" label-width="110px" label-suffix="：">
        <el-form-item label="地区编码">
          {{viewForm.areaCode}}
        </el-form-item>
        <el-form-item label="详细地址" >
          {{viewForm.detailAddress}}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 导出重名区县 -->
    <el-dialog title="导出重名区县" :visible.sync="multiOpen" width="400px">
      <el-form ref="multiForm" :model="multiForm" :rules="multiRules" label-width="110px" label-suffix="：">
        <el-form-item label="重名类型" prop="multiType">
          <el-select v-model="multiForm.multiType" placeholder="选择类型" size="small" style="width: 120px">
            <el-option key="full" label="全称重名" value="full"/>
            <el-option key="short" label="简称重名" value="short"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitExportForm">确定</el-button>
        <el-button @click="cancelExport">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  listArea,
  listChildArea,
  refreshCache,
  initArea,
  getDetailAddress
} from "@/api/tool/area";


export default {
  name: "Area",
  dicts:['area_level','area_init_year'],
  data() {
    return {
      tableType: 'tree',
      // 遮罩层
      loading: '',
      // 显示搜索条件
      showSearch: true,
      // 子地区数据
      treeList: [],
      //地区表格数据
      areaList: [],
      total:0,
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      //简称长度
      areaNameLenRange:[],
      // 全称长度
      extNameLenRange:[],
      // 查询参数
      queryParams: {
        current: 1,
        size: 10,
        areaName: null,
        parentCode: null,
        areaLevel: null,
        extName: null,
      },
      // 是否展开，默认全部折叠
      isExpandAll: false,
      form:{
        year: null,
        isAutoFill:true
      },
      rules: {
        year: [
          { required: true, message: '年份不能为空', trigger: 'blur' }
        ],
        isAutoFill: [
          { required: true, message: '是否补全不能为空', trigger: 'blur' }
        ]
      },
      viewOpen: false,
      viewForm: {},
      multiOpen:false,
      multiForm:{
        multiType:null
      },
      multiRules: {
        multiType: [
          { required: true, message: '重名类型不能为空', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.openFullScreen2()
    this.getChildList();
  },
  methods: {
    openFullScreen2() {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    handleNodeClick(data, treeNode, resolve) {
      listChildArea(data.areaCode).then(res => {
        data.children = []
        data.children = res.rows;
        resolve(res.rows)
      })
    },
    /** 查询地区列表 */
    getList() {
      let params = this.addNumberRange(this.queryParams, this.areaNameLenRange, 'AreaNameLen');
      params = this.addNumberRange(params, this.extNameLenRange, 'ExtNameLen');
      listArea(this.queryParams).then(res => {
        this.areaList = res.rows;
        this.total = res.total
      });
    },
    /** 查询子地区**/
    getChildList() {
      listChildArea(0).then(res => {
        this.treeList =  res.rows;
        this.loading.close()
      })
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        year: null,
        isAutoFill:true
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.current = 1;
      if(this.queryParams.areaName || this.queryParams.parentCode || this.queryParams.areaLevel || this.queryParams.extName
        || this.areaNameLenRange.length > 0 || this.extNameLenRange.length>0) {
        this.areaList = []
        this.tableType = 'table'
        this.getList()
      } else {
        this.treeList = []
        this.openFullScreen2()
        this.getChildList();
        this.tableType = 'tree'
        this.total = 0
      }
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.areaNameLenRange = []
      this.extNameLenRange = []
      this.queryParams.areaName=undefined;
      this.queryParams.parentCode=undefined;
      this.queryParams.areaLevel=undefined;
      this.queryParams.extName=undefined;
      this.resetForm("queryForm");
      this.handleQuery();
    },

    // 点击展开节点
    openTree(row, column, event){
      if (column.property&&row.hasChildren&&event.currentTarget.querySelector(".el-table__expand-icon")) {
        event.currentTarget.querySelector(".el-table__expand-icon").click();
      }
    },
    //增加小手样式
    cellStyle(data) {
      if (data.row.hasChildren) {
        return 'cursor:pointer;'
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.areaLevel===2) {
        return "row-blue";
      } else if(row.areaLevel===3) {
        return "row-green";
      }
    },
    /** 打开初始化弹窗 **/
    handleInit(){
      this.open = true;
      this.reset();
    },
    submitInitForm(){
      this.$refs["form"].validate(valid => {
        if (valid) {
          initArea(this.form).then(res => {
            if(res.code === 20000) {
              this.$modal.msgSuccess("初始化成功");
              this.open = false;
              this.handleQuery();
            } else {
              this.$modal.msgError(res.msg)
            }
          })
        }
      })
    },
    /** 刷新缓存按钮操作 */
    handleRefreshCache() {
      refreshCache().then(() => {
        this.$modal.msgSuccess("刷新成功");
      });
    },
    handleView(row){
      this.viewForm={
        areaCode:row.areaCode,
        detailAddress:null
      }
      getDetailAddress(row.areaCode).then(res => {
        if(res.flag) {
          this.viewForm.detailAddress=res.data
        }
      })
      this.viewOpen=true;
    },
    close(){
      this.viewOpen=false;
    },
    handleExportMultiCounty(){
      this.multiForm = {
        multiType: null
      };
      this.resetForm("multiForm");
      this.multiOpen=true;
    },
    submitExportForm(){
      this.$refs["multiForm"].validate(valid => {
        if (valid) {
          let name = this.multiForm.multiType === 'full' ? '全称重名区县' : '简称重名区县';
          this.download('admin/area/exportMultiCounty', {
            ...this.multiForm
          }, `${name}_${new Date().getTime()}.xlsx`)
        }
      })
    },
    cancelExport(){
      this.multiOpen=false;
    }
  }
};
</script>

